import { useOAProcessModalContext } from '@/contexts/OAProcessModalContext';
import OAProcessModal from '@/pages/Ticket/Email/Detail/components/OAProcessModal';

/**
 * 用于在顶层挂载 OA Modal 单例的 hooks
 */
export const useOAModals = () => {
  const { modalsState } = useOAProcessModalContext();

  // 渲染 OA 流程提交弹窗
  const renderOAProcessModal = () => {
    const modalData = modalsState.process || {};
    return (
      <OAProcessModal
        key="oa-process-modal"
        mode="process"
        visible={modalData.visible}
        emailDetail={modalData.emailDetail}
        visibleRouteKeys={modalData.visibleRouteKeys}
      />
    );
  };

  // 渲染 OA 流程列表弹窗
  const renderOAProcessListModal = () => {
    const modalData = modalsState.list || {};
    return (
      <OAProcessModal
        key="oa-process-list-modal"
        mode="list"
        visible={modalData.visible}
        emailDetail={modalData.emailDetail}
        visibleRouteKeys={modalData.visibleRouteKeys}
      />
    );
  };

  // 渲染 OA 流程提交弹窗
  const renderOASaasProcessModal = () => {
    const modalData = modalsState.saasProcess || {};
    return (
      <OAProcessModal
        key="oa-saas-process-modal"
        mode="saasProcess"
        visible={modalData.visible}
        emailDetail={modalData.emailDetail}
        visibleRouteKeys={modalData.visibleRouteKeys}
      />
    );
  };

  // 渲染 OA 流程列表弹窗
  const renderOASaasProcessListModal = () => {
    const modalData = modalsState.saasList || {};
    return (
      <OAProcessModal
        key="oa-saas-process-list-modal"
        mode="saasList"
        visible={modalData.visible}
        emailDetail={modalData.emailDetail}
        visibleRouteKeys={modalData.visibleRouteKeys}
      />
    );
  };

  // 渲染所有 OA 相关的 Modal
  const renderAllOAModals = () => {
    return (
      <>
        {renderOAProcessModal()}
        {renderOAProcessListModal()}
        {renderOASaasProcessModal()}
        {renderOASaasProcessListModal()}
      </>
    );
  };

  return {
    renderOAProcessModal,
    renderOAProcessListModal,
    renderOASaasProcessModal,
    renderOASaasProcessListModal,
    renderAllOAModals,
  };
};

